import React from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';

import * as Styled from 'shiftNotes/styles/NotesStack.style';

interface SubmissionResultProps {
  state: 'thanks' | 'regenerating';
}

export default function SubmissionResult({
  state,
}: SubmissionResultProps): JSX.Element {
  const { t } = useTranslation('pageShiftNotes');

  if (state === 'regenerating') {
    return (
      <Styled.LoadingPill role="status" aria-live="polite">
        <Styled.LoadingPillIcon aria-hidden="true">
          <General.Loading02 />
        </Styled.LoadingPillIcon>
        <Styled.LoadingPillLabel>
          {t('reflexFeedback.regenerating')}
        </Styled.LoadingPillLabel>
      </Styled.LoadingPill>
    );
  }

  return (
    <Styled.FeedbackResult role="status" aria-live="polite">
      <Styled.FeedbackResultIcon aria-hidden="true">
        <General.ThumbsUp />
      </Styled.FeedbackResultIcon>
      <Styled.FeedbackResultText>
        {t('reflexFeedback.thankYou')}
      </Styled.FeedbackResultText>
    </Styled.FeedbackResult>
  );
}
